module.exports = __webpack_public_path__ + "img/PINTURA.9b18222d.png";